import asArray from 'utils/arrays/asArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const fromArrayToCommatose = (ids) => (Array.isArray(ids) ? asArray(ids).join(',') : fromAnyToTrimmed(ids));

export default fromArrayToCommatose;
